import React from "react";
import DTImage from "../../assets/dhruvtara/dhruvtara.webp";

export default function Hero() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-12 md:px-8">
        <div className="flex justify-center">
          <img
            src={DTImage}
            className="w-full h-auto max-h-[500px] md:max-h-[600px] object-contain"
            alt="img"
          />
        </div>
        <div className="flex flex-col justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center md:text-left">
            Project Dhruvtara
          </h1>
          <p className="mt-6 text-center md:text-left">
            <span className="text-2xl font-bold text-[#54C7E4]">About</span>
            <br />
            <span className="text-[#00385B] text-lg underline italic">
              Empowering with Education
            </span>
            <br />
            <span className="text-[#00385B] text-lg">
              <strong>Project Dhruvtara</strong> is a flagship initiative by{" "}
              <strong>LEO Club, University of Delhi</strong>, aligned with the
              United Nations Sustainable Development Goal #4 –{" "}
              <strong>Quality Education</strong>. Rooted in the belief that
              education is the most powerful tool for empowerment, the project
              is dedicated to illuminating the lives of underprivileged children
              by providing them with access to meaningful learning opportunities
              and essential educational resources.
              <br />
              <br />
              With the motto <strong>"Empowering with Education"</strong>,
              Project Dhruvtara aims to bridge the educational divide and create
              environments where learning is engaging, inclusive, and accessible
              to all.
              <br />
              <br />
              Major initiatives under the project includes Library on Wheels,
              Chanakyavani Series, Knowledge Yard Series, Bootcamp, Akshar
              Volunteership among others. Each of these efforts is designed to
              nurture curiosity, boost confidence, and guide young minds toward
              a brighter, more informed future. Just like the{" "}
              <strong>Dhruvtara (Pole Star) </strong>that guides travelers
              through darkness, this project aspires to be a guiding light in
              the educational journey of every child it touches.
            </span>
            <br />
            <br />
            <span className="text-2xl font-bold text-[#54C7E4]">Vision</span>
            <br />
            <span className="text-[#00385B] text-lg">
              To create a sustainable, community-driven ecosystem where
              education becomes a tool of empowerment for children from
              economically challenged backgrounds.
            </span>
            <br />
            <br />
            <span className="text-2xl font-bold text-[#54C7E4]">Mission</span>
            <br />
            <span className="text-[#00385B] text-lg">
              • Bridge the gap between opportunity and access.
              <br />
              • Provide consistent mentorship and learning.
              <br />• Promote values of empathy, leadership, & responsibility
              among youth.
            </span>
            <br />
          </p>
        </div>
      </div>
    </>
  );
}
